import React from 'react';
import styled from 'styled-components';

export const ActionIconButtonWrapper = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
  min-width: 18px;

  &:hover:not(:disabled) {
    svg {
      path {
        fill-opacity: 1;
      }
    }
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--green-main);
    outline-offset: var(--xxxsmall-padding);
    border-radius: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const CancelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <rect width="18" height="18" rx="5" fill="white" />
    <path
      d="M5.44444 13.5L5 13.0556L8.55556 9.5L5 5.94444L5.44444 5.5L9 9.05556L12.5556 5.5L13 5.94444L9.44444 9.5L13 13.0556L12.5556 13.5L9 9.94444L5.44444 13.5Z"
      fill="#1C1B1F"
    />
  </svg>
);

const ConfirmIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <rect width="18" height="18" rx="5" fill="white" />
    <path
      d="M7.34928 12.5L4 9.21265L4.48116 8.74105L7.34928 11.5561L13.5195 5.5L14 5.97227L7.34928 12.5Z"
      fill="#209D7F"
    />
  </svg>
);

const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <rect width="18" height="18" rx="5" fill="white" />
    <path
      d="M10.1741 5.27823L10.831 5.91242L4.89655 11.8269V13.1039H6.15172L12.1258 7.16701L12.7483 7.78397L6.55172 14H4V11.4495L10.1741 5.27823ZM12.7483 7.78397L10.1741 5.27823L12.0362 3.41704C12.3144 3.13901 12.6577 3 13.0664 3C13.475 3 13.8167 3.14475 14.0914 3.43426L14.5879 3.91853C14.8626 4.20461 15 4.54525 15 4.94046C15 5.33568 14.8569 5.67633 14.5707 5.96241L12.7483 7.78397Z"
      fill="#1C1B1F"
      fillOpacity="0.6"
    />
  </svg>
);

const iconMap = {
  cancel: CancelIcon,
  confirm: ConfirmIcon,
  edit: EditIcon,
};

type ActionIconButtonProps = {
  onClick: () => void;
  icon: keyof typeof iconMap;
  'aria-label': string;
};

export const ActionIconButton: React.FC<ActionIconButtonProps> = ({
  onClick,
  icon: iconKey,
  'aria-label': ariaLabel,
}) => {
  const Icon = iconMap[iconKey];
  return (
    <ActionIconButtonWrapper
      onClick={onClick}
      aria-label={ariaLabel}
      type="button"
    >
      <Icon />
    </ActionIconButtonWrapper>
  );
};
